<footer>
    <div>
        <!-- <button mat-button (click)="onBrowse()">Browse</button>
        <button mat-button [routerLink]="['/search']">Search</button> -->
        <button class="about" mat-button (click)="onAbout()">About</button>
    </div>
    <div>
    </div>
</footer>